import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {PriceType} from "../../types/price.type";
import {ItemSetting} from "../../models/itemSetting.model";
import {PricePlanAlertsService} from "../../services/price-plan-alerts.service";
import {PricePlanService} from "../../services/price-plan-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {PricePlanRequestsService} from "../../services/price-plan-requests.service";
import {TaskCancellationStatusType} from "../../types/task-cancellation-status.type";
import {RoundingType} from "../../types/rounding.type";

export class ProgramVehicleViewCtrl implements IController {
  programId: string;
  priceType: PriceType;
  accountId: string;

  public programData: any;
  public programTypeMap: typeof PriceType = PriceType;
  public packageItemOptions: ItemSetting[];
  public isSaveAvailable: boolean;
  public cardsEnabledByIdMap: Object = {};
  public excludeOriginIds: any[] = [];
  public vehicleOptions: any[] = [];
  public editSectionsByIdMap: Object = {};
  public currencySymbol: string;
  public siteDistanceUnit: string;
  public isEditable: boolean;
  public taskCancellationStatuses: string[];
  public vehicleDataPickupCancellationExcludedStatusesMap: {};
  public vehicleDataDestinationCancellationExcludedStatusesMap: {};
  public isShowCancellationFeeSections: boolean;
  public roundingTypes: RoundingType[];
  public isShowRoundingType: boolean;


  constructor(private PricePlanService: PricePlanService, private confirmDialogService: ConfirmDialogService, private pricePlanRequestsService: PricePlanRequestsService,
              private pricePlanAlertsService: PricePlanAlertsService, private splitService, private $state) {
    this.currencySymbol = splitService.getCurrencySymbol();
    this.siteDistanceUnit = this.splitService.getSiteDistanceLargeUnit();
  }

  $onInit() {
    this.roundingTypes = Object.values(RoundingType);
    this._initValues();
  }

  onEditOrigin(vehicleData, index) {
    this.editSectionsByIdMap[vehicleData.id] = true;
    const vehicleDataCopy = angular.copy(vehicleData);

    if (!vehicleData.data) {
      vehicleDataCopy.data = vehicleData.parentData || {};
    }

    if (!vehicleDataCopy.data.vehiclePriceData || !vehicleDataCopy.data.vehiclePriceData.length) {
      vehicleDataCopy.data.vehiclePriceData = vehicleData.parentData?.vehiclePriceData || [];
    }

    if (!vehicleDataCopy.data.pickupCancellationFeesData || !vehicleDataCopy.data.pickupCancellationFeesData?.length) {
      vehicleDataCopy.data.pickupCancellationFeesData = vehicleData.parentData?.pickupCancellationFeesData || [];
    }

    if (!vehicleDataCopy.data.destinationCancellationFeesData || !vehicleDataCopy.data.destinationCancellationFeesData.length) {
      vehicleDataCopy.data.destinationCancellationFeesData = vehicleData.parentData?.destinationCancellationFeesData || [];
    }

    this.programData.vehicleData[index] = vehicleDataCopy;
    this._setVehicleDataTaskCancellationExcludedStatusesMap();

  }

  onAddOrigin($event, vehicleData?: string) {

    // const priceTypeDistanceUnit = this.priceType === this.programTypeMap.ByDistanceUnit;
    this._setExcludesOrigins();

    let dataItem;

    if (vehicleData) {
      const vehicleDataCopy = angular.copy(vehicleData);
      _.unset(vehicleDataCopy, 'id');
      dataItem = vehicleDataCopy
    } else {
      // if (priceTypeDistanceUnit) {
      //   dataItem = {
      //     isView: true,
      //     id: undefined,
      //     text: undefined,
      //     data: {
      //       vehiclePriceData: [{from: 0}]
      //     }
      //   };
      //   this.isEditable = true;
      // } else {
      //   dataItem = {
      //     isView: true,
      //     id: undefined,
      //     text: undefined,
      //   }
      // }
      dataItem = {
        isView: true,
        id: undefined,
        text: undefined,
      }
    }

    if (!this.programData.vehicleData) {
      this.programData.vehicleData = [];
    }


    this.programData.vehicleData.push(dataItem);
    this._onDataChange();
  }

  onOriginVehicleSelect(vehicleData, vehicle) {
    vehicleData.id = _.get(vehicle, 'id');
    vehicleData.text = _.get(vehicle, 'type');

    this.cardsEnabledByIdMap[vehicleData.id] = true;
    this._setExcludesOrigins();
    this._onDataChange();
  }


  onVehicleSelect(index, vehicle) {
    this.programData.vehicleData[index].id = _.get(vehicle, 'id');
    this.programData.vehicleData[index].text = _.get(vehicle, 'type');
    this._setExcludesOrigins();
    this._onDataChange();
  }

  onChange(index, vehicleData) {
    this.programData.vehicleData[index] = angular.copy(vehicleData);
    this._onDataChange();
  }

  // onVehicleRowDelete(index) {
  //   const text = 'Are you sure you want to delete this origin?';
  //   this.confirmDialogService.confirm('Delete Origin', text)
  //     .then(() => {
  //       this.programData.vehicleData.splice(index, 1);
  //       if (this.programData.vehicleData.length === 0) {
  //         this.isEditable = false;
  //       }
  //       this._setExcludesOrigins();
  //       this._onDataChange();
  //     })
  // }

  onEdit(vehicleData) {
    this.isEditable = true;

    const vehicleDataCopy = angular.copy(vehicleData);

    if (!vehicleData.data) {
      vehicleDataCopy.data = vehicleData.parentData || {};
    }

    if (!vehicleDataCopy.data.vehiclePriceData || !vehicleDataCopy.data.vehiclePriceData.length) {
      vehicleDataCopy.data.vehiclePriceData = vehicleData.parentData?.vehiclePriceData || [];
    }

    if (!vehicleDataCopy.data.pickupCancellationFeesData || !vehicleDataCopy.data.pickupCancellationFeesData?.length) {
      vehicleDataCopy.data.pickupCancellationFeesData = vehicleData.parentData?.pickupCancellationFeesData || [];
    }

    if (!vehicleDataCopy.data.destinationCancellationFeesData || !vehicleDataCopy.data.destinationCancellationFeesData.length) {
      vehicleDataCopy.data.destinationCancellationFeesData = vehicleData.parentData?.destinationCancellationFeesData || [];
    }

    this.programData.vehicleData[0] = vehicleDataCopy;
    this._setVehicleDataTaskCancellationExcludedStatusesMap();
  }

  onAddLocation(vehicleData, index, $event) {

    const vehicleDataCopy = angular.copy(this.programData.vehicleData);

    const dataItem = {
      from: undefined,
      to: undefined,
      value: undefined,
    }

    if (!vehicleData.data?.vehiclePriceData) {
      vehicleData.data.vehiclePriceData = [];
    }

    vehicleData.data.vehiclePriceData.push(dataItem);
    vehicleDataCopy[index] = vehicleData;
    this.programData.vehicleData = vehicleDataCopy;

    this._onDataChange();
  }

  onAddCancellationFee(vehicleData, taskType: string, vehicleDataIndex: number) {

    const taskCancellationFeesCopy = angular.copy(vehicleData.data[taskType]);
    let status;

    if (taskType === 'pickupCancellationFeesData') {
      status = this.taskCancellationStatuses.find(t => {
        return !this.vehicleDataPickupCancellationExcludedStatusesMap[vehicleDataIndex].includes(t);
      })
    } else {
      status = this.taskCancellationStatuses.find(t => {
        return !this.vehicleDataDestinationCancellationExcludedStatusesMap[vehicleDataIndex].includes(t);
      })
    }

    const newCancellationFee = {
      status: status,
      value: {
        value: 0,
        type: "Fixed"
      }
    }

    taskCancellationFeesCopy.push(newCancellationFee);
    this.programData.vehicleData[vehicleDataIndex].data[taskType] = taskCancellationFeesCopy;
    this._setVehicleDataTaskCancellationExcludedStatusesMap();


    this._onDataChange();
  }

  onUpdateCancellationFee(cancellationFee, cancellationFeeIndex, taskType: string, vehicleDataIndex: number) {
    const taskCancellationFeesCopy = [...this.programData.vehicleData[vehicleDataIndex].data[taskType]]
    taskCancellationFeesCopy[cancellationFeeIndex] = cancellationFee;

    this.programData.vehicleData[vehicleDataIndex].data[taskType] = taskCancellationFeesCopy;
    this._setVehicleDataTaskCancellationExcludedStatusesMap();

    this._onDataChange();
  }

  onDeleteCancellationFee(cancellationFeeIndex, taskType: string, vehicleDataIndex: number) {
    const taskCancellationFeesCopy = [...this.programData.vehicleData[vehicleDataIndex].data[taskType]]
    taskCancellationFeesCopy.splice(cancellationFeeIndex, 1);

    this.programData.vehicleData[vehicleDataIndex].data[taskType] = taskCancellationFeesCopy;

    this._setVehicleDataTaskCancellationExcludedStatusesMap();
    this._onDataChange();

  }

  onDeleteOrigin(vehicleData, $index) {
    if ($index > -1) {
      const text = 'Are you sure you want to delete this origin?';
      this.confirmDialogService.confirm('Delete Origin', text)
        .then(() => {
          this._removeViewOrigin($index)
          this._onDataChange();
        })
    }
  }

  onDeleteLocation(location, locationIndex, vehicleDataIndex) {
    if (locationIndex > -1) {
      const programDataCopy = {...this.programData};
      programDataCopy.vehicleData[vehicleDataIndex].data.vehiclePriceData.splice(locationIndex, 1);

      this.programData = programDataCopy;
      this._onDataChange(true);
    }
  }

  onUpdateLocation(location, index, vehicleData, vehicleDataIndex) {

    vehicleData.data.vehiclePriceData[index] = location;
    const allVehicleData = angular.copy(this.programData.vehicleData);
    allVehicleData[vehicleDataIndex] = vehicleData;
    this.programData.vehicleData = allVehicleData;
    this._onDataChange();
  }

  onSaveProgram(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {

        const originWithoutLocation = _.find(this.programData.vehicleData, (vehicleData) => {
          return !vehicleData.data?.vehiclePriceData.length
        })

        if (!!originWithoutLocation) {
          this.pricePlanAlertsService.updatePreferencesOriginMissingLocationsWarning(originWithoutLocation)
          return;
        }

        this.PricePlanService.editProgramConfiguration(this.programId, this.programData, this.accountId)
          .then((programData) => {
            this.programData = programData;
            this.editSectionsByIdMap = {};
            this.isSaveAvailable = false;
          })
          .finally(() => {
            this.isEditable = false;
          })
      }
    }
  }

  onCancelChanges() {
    this._initValues();
    this.isSaveAvailable = false;
  }

  _initValues() {
    this.isShowCancellationFeeSections = this.$state.current.name.match('contract.details.service');
    this.taskCancellationStatuses = Object.keys(TaskCancellationStatusType);
    this._getProgramData();
    this._getProgramVehicleOptions();
  }

  onChangeRoundingType() {
    this._onDataChange();
  }

  private _setVehicleDataTaskCancellationExcludedStatusesMap() {
    this.vehicleDataPickupCancellationExcludedStatusesMap = {};
    this.vehicleDataDestinationCancellationExcludedStatusesMap = {};
    this.programData.vehicleData.forEach((vd, index) => {
      const pickupTaskCancellationStatuses = vd.data.pickupCancellationFeesData?.map(cancellationFee => cancellationFee.status);
      if (!!pickupTaskCancellationStatuses) {
        this.vehicleDataPickupCancellationExcludedStatusesMap[index] = this.taskCancellationStatuses.filter(status => {
          return pickupTaskCancellationStatuses.includes(status);
        });
      }

      const destinationTaskCancellationStatuses = vd.data.destinationCancellationFeesData?.map(cancellationFee => cancellationFee.status);
      if (!!destinationTaskCancellationStatuses) {
        this.vehicleDataDestinationCancellationExcludedStatusesMap[index] = this.taskCancellationStatuses.filter(status => {
          return destinationTaskCancellationStatuses.includes(status);
        });
      }
    })
  }


  private _getProgramData() {
    this.PricePlanService.getProgramData(this.programId, this.accountId, undefined, undefined, true)
      .then((programData) => {
        this.programData = programData;
        this._setVehicleDataTaskCancellationExcludedStatusesMap();
      })
  }

  private _getProgramVehicleOptions() {
    this.pricePlanRequestsService.getPricePlanPreferences(this.programId, ['VehicleFactor'], this.accountId)
      .then((res) => {
        this.vehicleOptions = _.chain(_.get(res, 'data[0].value', []))
          .filter((vehicle) => {
            return !!vehicle.enabled || !!vehicle.parentEnabled
          })
          .map((filteredVehicle) => {
            return {id: filteredVehicle.id, name: filteredVehicle.description}
          })
          .value();
      })
  }

  private _removeViewOrigin(index) {
    const vehicleDataCopy = angular.copy(this.programData.vehicleData);
    vehicleDataCopy.splice(index, 1);

    this.programData.vehicleData = vehicleDataCopy;
    this._setExcludesOrigins();
  }

  private _setExcludesOrigins() {
    this.excludeOriginIds = _.compact(_.map(this.programData.vehicleData, 'id'));
  }

  private _onDataChange(value?) {
    this.isSaveAvailable = _.isUndefined(value) ? true : value;
  }


}

angular
  .module('bringoz.admin.pricePlan')
  .component('programVehicleView', {
    bindings: {
      programId: '<',
      priceType: '<',
      accountId: '<?',
      isShowRoundingType: '<?'
    },
    template: require('./program-vehicle-view.html').default,
    controller: ProgramVehicleViewCtrl
  });
